<template>
  <b-form @submit.prevent="savePortage()">
    <b-row class="form-group">
      <b-col sm="5">
        <label for>ETB</label>
        <br>
        <date-picker
          v-model="rq.etb"
          lang="es"
          type="datetime"
          required
          format="DD/MM/YYYY HH:mm"
          v-on:change="changeETB"
          :time-picker-options="{ start: '00:00', step: '00:05', end: '23:55' }"
        ></date-picker>
      </b-col>
    </b-row>

    <b-row class="form-group">
      <b-col sm="5">
        <label for>CUTOFF / CIERRE</label>
        <br>
        <date-picker
          v-model="rq.cutoff"
          lang="es"
          type="datetime"
          required
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:05', end: '23:55' }"
        ></date-picker>
      </b-col>
      <b-col sm="5" v-if="operation.code_service === constants.IMPORTACION">
        <label for>TD</label>
        <br>
        <date-picker
          v-model="rq.td"
          lang="es"
          type="datetime"
          required
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:05', end: '23:55' }"
        ></date-picker>
      </b-col>
      <b-col sm="5" v-if="operation.code_service === constants.EXPORTACION">
        <label for>STACKING</label>
        <br>
        <date-picker
          v-model="rq.stacking"
          lang="es"
          type="datetime"
          required
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:05', end: '23:55' }"
        ></date-picker>
      </b-col>
    </b-row>

    <b-row class="form-group">
      <b-col sm="5">
        <label for>Linea Naviera</label>
        <v-select
          v-model="shippingLine"
          :options="shippingLines"
          label="name"
          :value="rq.shipping_line_id"
          :on-change="setShippingLine"
        ></v-select>
      </b-col>
      <b-col sm="5">
        <label for>Nombre de nave</label>
        <input type="text" v-model="rq.ship_name" class="form-control" required>
      </b-col>
    </b-row>

    <b-row class="form-group">
      <b-col sm="5">
        <label for>Puerto</label>
        <v-select
          v-model="port"
          :options="ports"
          label="name"
          :value="rq.port_id"
          :on-change="setPort"
        ></v-select>
      </b-col>

      <b-col sm="5">
        <label for>Tipo de operación</label>
        <v-select
          v-model="operation"
          :options="operations"
          label="name"
          :value="rq.operation_id"
          :on-change="setOperation"
        ></v-select>
      </b-col>
    </b-row>

    <b-row class="form-group">
      <b-col sm="5">
        <label for>Cantidad de contenedores</label>
        <input type="number" v-model="rq.total_containers" class="form-control" required>
      </b-col>
      <!-- <b-col sm="5">
        <label for>Cantidad de contenedores por hora</label>
        <input type="number" v-model="rq.ratio" class="form-control" required>
      </b-col>-->
    </b-row>

    <b-row>
      <b-col sm="5">
        <p v-if="rq.total_containers > 0 && port.hours > 0">
          Se necesitan
          <strong>{{Math.ceil(rq.total_containers / (port.hours))}}</strong> camiones por hora.
          <br>
          <span style="font-size: 11px">Cálculo en base a {{port.hours}} horas en {{port.code}}</span>
        </p>
      </b-col>
    </b-row>
    <br>
    <div v-if="['ECE', 'DCE'].includes(operation.code)">
      <b-row v-for="(chargeType, j) in specialChargeTypes" :key="j" class="form-group">
        <b-col sm="4">
          <label for>{{`Cantidad de contenedores ${chargeType.name}`}}</label>
          <input
            type="number"
            v-model="containersByCharge[chargeType.id]"
            class="form-control"
            required
          >
        </b-col>
      </b-row>
    </div>

    <div slot="footer">
      <input type="submit" class="btn btn-primary" value="Enviar" />
    </div>
  </b-form>
</template>

<script>
import api from "@/helpers/api";
import moment from "moment";
import constants from "@/constants";
export default {
  props: ["service_id"],
  data() {
    return {
      rq: {},
      ports: [],
      service_types: [],
      service_type: {},
      operations: [],
      operation: {},
      specialChargeTypes: [],
      port: {},
      shippingLines: [],
      shippingLine: {},
      containersByCharge: {},
      constants
    };
  },
  mounted() {
    api.get("/charge_types").then(response => {
      this.specialChargeTypes = response.charge_types.filter(s => s.portage);
    });

    this.constants = constants;
    if (this.service_id) {
      api.get(`/portage/${this.service_id}`).then(response => {
        this.rq = response.portage;
        this.port = this.rq.port;
        this.shippingLine = this.rq.shipping_line;
        this.operation = this.rq.operation;
        this.rqs = response.requeriments;
        if (["ECE", "DCE"].includes(this.operation.code)) {
          this.specialChargeTypes.map(sch => {
            this.containersByCharge[sch.id] = this.rqs.filter(
              rq => rq.charge_type_id === sch.id
            ).length;
          });
        }

        let current_date = moment().format("YYYY-MM-DD HH:mm:ss");
        let current_time = moment().format("HH:mm:ss");
        let next_date = moment()
          .add(1, "day")
          .format("YYYY-MM-DD");
        let service_date = moment(this.rq.landing_date).format(
          "YYYY-MM-DD HH:mm:ss"
        );

        if (current_date >= service_date) {
          this.$toastr.warning(
            "No es posible editar un servicio pasado o en proceso",
            "Porteo",
            { positionClass: "toast-top-center", closeButton: true }
          );
          this.$router.push({ path: `/portage/list` });
        }
      });
    }

    api.get("/ports").then(response => {
      this.ports = response.ports;
    });

    api.get("/operations").then(response => {
      this.operations = response.operations;
    });

    api.get("/shipping_lines").then(response => {
      this.shippingLines = response.shipping_lines;
    });

    api.get("/service_types").then(response => {
      this.service_types = response.service_types.filter(s => s.portage);
    });
  },
  methods: {
    setPort(obj) {
      this.port = obj ? obj : null;
      this.rq.port_id = obj ? obj.id : null;
    },
    setOperation(obj) {
      this.operation = obj ? obj : {};
      if (!obj || !["ECE", "DCE"].includes(obj.code))
        this.containersByCharge = {};
      this.rq.operation_id = obj ? obj.id : null;
      this.rq.service_portage_id = obj ? obj.service_type_id : null;
      this.changeETB();
    },
    setShippingLine(obj) {
      this.rq.shipping_line_id = obj ? obj.id : null;
    },
    checkAmounts(containersByCharge) {
      let specialContAmount = 0;
      containersByCharge.map(cont => (specialContAmount += cont.value));
      return specialContAmount === parseInt(this.rq.total_containers);
    },
    changeETB() {
      if (this.rq.etb && this.operation.code_service) {
        switch (this.operation.code_service) {
          case constants.IMPORTACION:
            this.rq.stacking = null; //moment().add().format('')
            this.rq.td = moment(this.rq.etb)
              .add(24, "hour")
              .format("YYYY-MM-DD HH:mm");
            this.rq.cutoff = moment(this.rq.td)
              .add(48, "hour")
              .format("YYYY-MM-DD HH:mm");

            break;
          case constants.EXPORTACION:
            this.rq.cutoff = moment(this.rq.etb)
              .add(-24, "hours")
              .format("YYYY-MM-DD HH:mm");
            this.rq.stacking = moment(this.rq.cutoff)
              .add(-48, "hours")
              .format("YYYY-MM-DD HH:mm");
            this.rq.td = null;

            break;
        }
      } else {
        this.rq.cutoff = this.rq.stacking = this.rq.td = null;
      }
    },
    savePortage() {
      const containersByCharge = Object.entries(this.containersByCharge).map(
        ([key, value]) => ({ key, value: parseInt(value) })
      );
      if (["ECE", "DCE"].includes(this.operation.code)) {
        if (this.checkAmounts(containersByCharge))
          this.rq.containersByCharge = containersByCharge;
        else {
          this.$toastr.error("Cantidades no coinciden. Verifica las cantidades de cada tipo de carga.", "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return false;
        }
      }
      if (this.service_id) {
        delete this.rq.port;
        delete this.rq.shipping_line;
        delete this.rq.operation;

        if (!this.rq.etb) {
          this.$toastr.error("Debes ingresar fecha ETB", "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        } else {
          this.rq.etb = moment(this.rq.etb).format("YYYY-MM-DD HH:mm:ss");
          this.rq.td = this.rq.td
            ? moment(this.rq.td).format("YYYY-MM-DD HH:mm:ss")
            : null;
          this.rq.stacking = this.rq.stacking
            ? moment(this.rq.stacking).format("YYYY-MM-DD HH:mm:ss")
            : null;
          this.rq.cutoff = this.rq.cutoff
            ? moment(this.rq.cutoff).format("YYYY-MM-DD HH:mm:ss")
            : null;
          // Actualizar servicio de porteo
          api.put(`/portages/${this.service_id}`, this.rq).then(response => {
            if (response.success) {
              this.$toastr.success("Porteo actualizado", "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
            } else {
              this.$toastr.error(response.message, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
            }
          });
        }
      } else {
        // Nuevo servicio de porteo

        if(this.rq.total_containers <= 0){
          this.$toastr.error("Debes indicar una cantidad válida", "Cantidad de contenedores", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          return
        }

        if (!this.rq.etb) {
          this.$toastr.error("Debes ingresar fecha de inicio", "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        } else {
          this.rq.etb = moment(this.rq.etb).format("YYYY-MM-DD HH:mm:ss");
          this.rq.td = this.rq.td
            ? moment(this.rq.td).format("YYYY-MM-DD HH:mm:ss")
            : null;
          this.rq.stacking = this.rq.stacking
            ? moment(this.rq.stacking).format("YYYY-MM-DD HH:mm:ss")
            : null;
          this.rq.cutoff = this.rq.cutoff
            ? moment(this.rq.cutoff).format("YYYY-MM-DD HH:mm:ss")
            : null;

          this.rq.ratio = Math.ceil(this.rq.total_containers / this.port.hours);

          api.post("/portages", this.rq).then(response => {
            if (response.success)
              this.$toastr.success(`Porteo creado exitosamente`, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
            else
              this.$toastr.error(response.message, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
          });
        }
      }
    }
  }
};
</script>

<style>
</style>
